<div class="modal-header" cdkDrag cdkDragRootElement=".modal-content" cdkDragHandle>
  <h5 class="modal-title">Pre-Exchange Checklist</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body">

  <div *ngIf="error" class="alert alert-danger">{{errorMessage}}</div>

  <div *ngIf="!error">

    <!-- Header row -->
    <div class="d-flex align-items-center border-bottom py-2 gap-3 fw-semibold small">
      <div class="flex-grow-1">Check</div>
      <div style="width: 150px;">Response</div>
      <div style="width: 200px;">Commentary</div>
      <div style="width: 120px;">Completed by / When</div>
      <div style="width: 32px;"></div>
    </div>

    <!-- Item rows -->
    <div *ngFor="let item of items" class="d-flex align-items-center border-bottom py-2 gap-3">

      <div class="flex-grow-1 small" [innerHTML]="item.preExchangeChecklistItem.itemText"></div>

      <div style="width: 150px;" class="flex-shrink-0">
        <div class="btn-group" role="group">
          <input type="radio" class="btn-check" [name]="'response_' + item.id" [id]="'yes_' + item.id"
            [value]="1" [(ngModel)]="item.checklistResponseType" (ngModelChange)="updateValue(item)">
          <label class="btn btn-outline-success btn-sm" [for]="'yes_' + item.id">Yes</label>

          <input type="radio" class="btn-check" [name]="'response_' + item.id" [id]="'no_' + item.id"
            [value]="2" [(ngModel)]="item.checklistResponseType" (ngModelChange)="updateValue(item)">
          <label class="btn btn-outline-success btn-sm" [for]="'no_' + item.id">No</label>

          <input type="radio" class="btn-check" [name]="'response_' + item.id" [id]="'na_' + item.id"
            [value]="3" [(ngModel)]="item.checklistResponseType" (ngModelChange)="updateValue(item)">
          <label class="btn btn-outline-success btn-sm" [for]="'na_' + item.id">N/A</label>
        </div>
      </div>

      <div style="width: 200px;" class="flex-shrink-0">
        <textarea class="form-control form-control-sm"
          style="resize: none;"
          rows="2"
          maxlength="500"
          [(ngModel)]="item.commentary"
          (change)="updateCommentary(item)"></textarea>
      </div>

      <div style="width: 120px;" class="flex-shrink-0 small text-muted fst-italic">
        <span *ngIf="item.byUser">
          {{item.byUser.firstName.charAt(0)}}{{item.byUser.lastName.charAt(0)}}<br>
          {{item.dateEntered | date:'dd/MM/yyyy HH:mm:ss'}}
        </span>
      </div>

      <div style="width: 32px;" class="flex-shrink-0">
        <button *ngIf="item.checklistResponseType" type="button"
          class="btn btn-secondary btn-sm"
          (click)="clearValue(item)">
          <fa-icon [icon]="faTimes"></fa-icon>
        </button>
      </div>

    </div>
  </div>

</div>

<div class="modal-footer" *ngIf="!error">
  <button type="button" class="btn btn-success" (click)="generatePDF()">
    Generate PDF
  </button>
</div>